module.exports = __webpack_public_path__ + "static/media/S (12).3477a83f.jpg";